import { useContext, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UserContext from '../../../store/user-context';

import { ACTIONS } from './ConversationParts';
import useFetch from '../../../hooks/use-fetch';
import AudioListener from './AudioListener';
import { useSpeechSDK } from '../../Helpers/Conversation/SpeechDetection';
import useAnalyticsEventTracker from '../../../hooks/use-analytics';

const ConversationButton = (props) => {
  const dispatch = useDispatch();
  const sceneID = useSelector((state) => state.currentSceneID);
  const score = useSelector((state) => state.currentButtonScore);
  const activeButton = useSelector((state) => state.activeButton);
  const activeSection = useSelector((state) => state.activeSection);
  const playButtonAudio = useSelector((state) => state.playButtonAudio);
  const conversationData = useSelector((state) => state.conversationData);
  const lesson = parseInt(useSelector((state) => state.currentLesson));
  const { user } = useContext(UserContext);
  const { initFunc: dispatchProgressUpdate } = useFetch();
  const gaEventTracker = useAnalyticsEventTracker(`Lesson ${conversationData.lesson}`);

  //Flag consts
  let localLang = user.user.language || 'british'; //default to british if no value exists
  localLang = localLang === 'british' ? 'english' : localLang;
  const localFlag = `/flags/${localLang}.png`;
  const learning = user.user.learning;
  const learningFlag = `/flags/${learning}.png`;

  const completeButton = () => {
    dispatch({
      type: 'resetConversationButton',
    });

    props.dispatch({
      type: ACTIONS.COMPLETE_BUTTON,
      payload: { id: props.buttonData.id },
    });
  };

  const buttonSkipped = () => {
    const { apiUrl } = window['appConfig'];
    const conversationId = parseInt(activeSection) + 1; //activeSection is 0 based so need to add 1 for api
    let fetchData = new URLSearchParams();
    fetchData.append('lesson', lesson);

    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: fetchData,
    };

    const progressUrl = `${apiUrl}/progress/skip/${sceneID}/${conversationId}/${props.buttonData.splitNumber}`;

    gaEventTracker('Sentence Skipped', `${conversationData.location} ${conversationData.sceneName} Lesson ${conversationData.lesson} Sentence ${parseInt(props.id) + 1} ${`Split ${props.buttonData.splitNumber}`}`)

    dispatchProgressUpdate({ url: progressUrl, options: fetchOptions });

    completeButton();
  };

  // eslint-disable-next-line no-unused-vars
  const toggleButtonStatus = (e) => {
    if (!document.getElementById('button_audio_player').paused) {
      // alert('please wait for audio to finish');
      return;
    }

    props.dispatch({
      type: ACTIONS.TOGGLE_BUTTON,
      payload: { id: props.buttonData.id },
    });

    //Play if button isn't toggled when we click
    //Check against the previous order item
    let originalButtonsOrder = [...props.allButtons];

    // Get the non random order
    originalButtonsOrder.sort(function (a, b) {
      let keyA = a.id,
        keyB = b.id;
      // Compare the 2 keys
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    const buttonIndex = originalButtonsOrder.findIndex((object) => {
      return object.splitNumber === props.buttonData.splitNumber;
    });

    let previousIndex =
      parseInt(buttonIndex) - 1 < 0 ? 0 : parseInt(buttonIndex) - 1;

    if (
      !props.buttonData.toggled
      // activeButton === props.buttonData.splitNumber - 1
    ) {
      //button order 1 can play if others aren't checked
      if (parseInt(props.buttonData.splitNumber) === 1) {
        playAudio();
      } else {
        //Check if previous button is complete
        if (originalButtonsOrder[previousIndex].complete) {
          playAudio();
        }
      }
    }
  };

  let buttonClasses = 'conversation-button';

  if (props.buttonData.error === true) {
    buttonClasses = 'conversation-button conversation-button--error';
  } else if (props.buttonData.toggled === true) {
    buttonClasses = 'conversation-button conversation-button--active';
  } else if (playButtonAudio && props.buttonData.splitNumber !== activeButton) {
    buttonClasses = 'conversation-button conversation-button--disabled';
  } else {
    buttonClasses = 'conversation-button';
  }

  const playAudio = () => {
    dispatch({
      type: 'playButtonAudio',
      payload: { buttonOrder: props.buttonData.splitNumber },
    });

    if (
      useSpeechSDK &&
      props.buttonData.splitNumber === 1 &&
      activeSection === 0
    ) {
      //need timeout to ensure audio src is set before trying to load and play
      setTimeout(function () {
        document.getElementById('button_audio_player').load();
        document.getElementById('button_audio_player').play();
      }, 100);
    }
  };

  let content =
    lesson !== 2 ? (
      <Fragment>
        <img src={localFlag} alt={localLang} className="flag flag--local" />
        {props.buttonData.toggled && <p>{props.buttonData.learningLang}</p>}
        {!props.buttonData.toggled && <p>{props.buttonData.nativeLang}</p>}
        <img
          src={learningFlag}
          alt={learning}
          className="flag flag--learning"
        />
      </Fragment>
    ) : (
      <p>{props.buttonData.learningLang}</p>
    );

  useEffect(() => {
    //Only complete for active button
    if (
      score >= 65 &&
      activeButton === props.buttonData.splitNumber &&
      lesson === 1
    ) {
      //<location> <objective name & level> <Scene Name> <Lesson> <Sentence> <Part>
      gaEventTracker('Sentence Passed', `${conversationData.location} ${conversationData.sceneName} Lesson ${conversationData.lesson} Sentence ${parseInt(props.id) + 1} ${`Split ${props.buttonData.splitNumber}`}`)
      setTimeout(function () {
        completeButton();
      }, 1500);
    }
    
    if (
      score !== null &&
      score < 65 &&
      activeButton === props.buttonData.splitNumber &&
      lesson === 1
    ) {
      gaEventTracker('Sentence Failed', `${conversationData.location} ${conversationData.sceneName} Lesson ${conversationData.lesson} Sentence ${parseInt(props.id) + 1} ${`Split ${props.buttonData.splitNumber}`}`)
    }
    
  }, [score]);

  useEffect(() => {
    if (props.buttonData.toggled === true) {
      dispatch({
        type: 'setActiveButton',
        payload: { activeButton: props.buttonData.splitNumber },
      });

      if (lesson === 2) {
        completeButton();
      }
    } else {
      dispatch({
        type: 'buttonUntoggled',
      });
    }
  }, [props.buttonData.toggled]);
  return (
    <div
      className={`button-container 
      ${props.buttonData.active || props.buttonData.complete ? 'button-container--active' : ''}
      `}
    >
      <div
        key={props.buttonKey}
        className={buttonClasses}
        data-id={props.id}
        onClick={toggleButtonStatus}
      >
        {content}
      </div>
      {lesson === 1 && (
        <AudioListener
          buttonToggled={props.buttonData.toggled}
          buttonComplete={props.buttonData.complete}
          completeButton={buttonSkipped}
          part={props.buttonData.splitNumber}
          toggleButtonStatus={toggleButtonStatus}
        />
      )}
    </div>
  );
};

export default ConversationButton;
